import { render } from "./ListAlbum.vue?vue&type=template&id=4857006d&scoped=true"
import script from "./ListAlbum.vue?vue&type=script&lang=js"
export * from "./ListAlbum.vue?vue&type=script&lang=js"

import "./ListAlbum.vue?vue&type=style&index=0&id=4857006d&scoped=true&lang=css"

import exportComponent from "/opt/FE_Compro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4857006d"]])

export default __exports__